import { render, staticRenderFns } from "./douyinGroupMalldetails.vue?vue&type=template&id=52f11b7e"
import script from "./douyinGroupMalldetails.vue?vue&type=script&lang=js"
export * from "./douyinGroupMalldetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports